export default __webpack_public_path__ + "static/media/freshman.75662e6d.jpg";